/**
 * 복제한 것의 이름 — "로비 기본" → "로비 기본 (사본)", 이미 있으면 "(사본 2)", "(사본 3)".
 *
 * 같은 이름을 그대로 두면 목록에 똑같은 줄이 둘 생겨, 어느 것을 고치고 어느 것이 원본인지 알 수 없다.
 * 사본을 또 복제하면 "(사본) (사본)" 으로 늘어나지 않게 꼬리를 떼고 다시 붙인다.
 */
export function copyName(name: string, taken: readonly string[]): string {
  const base = name.replace(/ \(사본(?: \d+)?\)$/, '');
  const used = new Set(taken);
  let candidate = `${base} (사본)`;
  for (let n = 2; used.has(candidate); n += 1) candidate = `${base} (사본 ${n})`;
  return candidate;
}
